var _circle, _circle2, _circle3, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOrderStatus5B(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 81 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 40.2937,
    cy: 40,
    r: 40,
    fill: "#F6AE2C"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 40.2937,
    cy: 40,
    r: 38,
    fill: "white"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 40.2937,
    cy: 40,
    r: 38,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50.6888 29.395C51.1818 28.9256 51.8379 28.6661 52.5186 28.6713C53.1993 28.6764 53.8514 28.9458 54.3373 29.4226C54.8232 29.8994 55.1048 30.5463 55.1228 31.2268C55.1408 31.9073 54.8938 32.5682 54.4338 33.07L40.4688 50.535C40.2286 50.7937 39.9388 51.0012 39.6166 51.1453C39.2944 51.2894 38.9465 51.367 38.5936 51.3735C38.2408 51.3801 37.8902 51.3154 37.5629 51.1833C37.2356 51.0513 36.9383 50.8546 36.6888 50.605L27.4278 41.344C27.1699 41.1037 26.963 40.8139 26.8195 40.4919C26.6761 40.1699 26.5989 39.8223 26.5927 39.4698C26.5865 39.1174 26.6513 38.7673 26.7833 38.4404C26.9154 38.1136 27.1119 37.8166 27.3611 37.5674C27.6104 37.3181 27.9073 37.1216 28.2342 36.9896C28.561 36.8576 28.9111 36.7927 29.2636 36.7989C29.6161 36.8052 29.9637 36.8823 30.2856 37.0258C30.6076 37.1693 30.8974 37.3761 31.1378 37.634L38.4668 44.9595L50.6223 29.472C50.6441 29.4451 50.6675 29.4194 50.6923 29.395H50.6888Z",
    fill: "#474747"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrderStatus5B);
export default __webpack_public_path__ + "static/media/orderStatus5b.f1115220a5f7df4602e4fffe06dfc407.svg";
export { ForwardRef as ReactComponent };